import { combineReducers } from "redux";

import Auth from "./auth/reducer";
import Layout from "./layout/reducer";
import MyAccount from './My-Account/reducer'

const rootReducer = combineReducers({
  Auth,
  Layout,
  MyAccount
});

export default rootReducer;
